
// ***********
// ** V: 1.3
// ***********




SLIDE_VERTICAL = 0;
SLIDE_HORIZONTAL = 1;

circleRotate = 0;
previousScroll = 0;
window.circleTransform = 'translate(-50%, -55%)';
previousTimeStamp = 0;
easeCount = 0;
easeScrolling = false;
pianoBlur = 40;
instrumentVideoIsPlaying = false;
instrumentVideoClicked = false;
titleBlur = 5;
scrollPercentage = 0;

buySectionStick = false;
buySectionStickPos = 0;
menuUnderlayVisible = false;

submittedNewsletter = false;
addedToCart = false;


circleBlur = 0;
circleScale = 1;
circleRotate = 1;
videoCurrentTime = 0;
const isFirefox = navigator.userAgent.toLowerCase().includes('firefox');
const isMobile = window.innerWidth <= 1250 && window.matchMedia("(orientation: portrait)").matches;

// window.currentPage
// 0 -> HOME
// 1 -> ABOUT
// 2 -> INSTRUMENTS
// 3 -> PIANO
window.PAGE_HOME = 0;
window.PAGE_ABOUT = 1;
window.PAGE_INSTRUMENTS = 2;
window.PAGE_PIANO = 3;
window.PAGE_CART = 4;
window.PAGE_TEAM = 5;
window.PAGE_PRIVACY = 6;
window.PAGE_GENERIC = 100;

clipPaths = [0, 0, 0, 0, 0];
clipFixed = [false, false, false, false, false];
waterDisplay = "block";

function scrollToDefaultPos() {
    if(window.currentPage == window.PAGE_PIANO) {
    } else {
        $(window).scrollTop(0);
    }
}

$(document).on({
    mouseenter: function () {
        $('.cursor').toggleClass('animate');
    },
    mouseleave: function () {
        $('.cursor').toggleClass('animate');
    }
}, ".menu-link"); 

$(document).on({
    mouseenter: function () {
        $('.cursor').toggleClass('animate');
    },
    mouseleave: function () {
        $('.cursor').toggleClass('animate');
    }
}, ".text-link"); 

$(document).on({
    mouseenter: function () {
        $('.cursor').toggleClass('animate');
    },
    mouseleave: function () {
        $('.cursor').toggleClass('animate');
    }
}, ".svg-wrapper"); 

function detectCurrentPage() {
    window.currentPage = 0;
    this._background = this._backgroundMain;
    if(document.URL.toLowerCase().indexOf('piano') != -1) {
      window.currentPage = window.PAGE_PIANO;
      this._background = this._backgroundInstruments;
    } else if(document.URL.toLowerCase().indexOf('instruments') != -1) {
      window.currentPage = window.PAGE_INSTRUMENTS;
    } else if(document.URL.toLowerCase().indexOf('about') != -1) {
      window.currentPage = window.PAGE_ABOUT;
    } else if(document.URL.toLowerCase().indexOf('cart') != -1) {
      window.currentPage = window.PAGE_CART;
    } else if(document.URL.toLowerCase().indexOf('team') != -1) {
      window.currentPage = window.PAGE_TEAM;
    }  else if(document.URL.toLowerCase().indexOf('faq') != -1 || document.URL.toLowerCase().indexOf('eula') != -1 || document.URL.toLowerCase().indexOf('privacy') != -1) {
      window.currentPage = window.PAGE_GENERIC;
    } else {
        window.currentPage = window.PAGE_HOME;
    }
}
detectCurrentPage();

// ***  MOBILE WORKAROUND
// CHECK IF COOKIE WRAPPER HAS LOADED
// IF SO, CHANGE THE WIDTH TO FIT THE PAGE
// ***
wrapperCheck = 0;
function checkWrapper() {
  cookieWrapper = document.getElementsByClassName('cookieconsent-wrapper');
    if(cookieWrapper.length>0) {
      cookieWrapper[0].setAttribute('style', 'width: auto !important');
    } else {
      if(wrapperCheck < 150) window.requestAnimationFrame(checkWrapper);
      wrapperCheck += 1;
    }
}

function renderSketch() {
    window.sketch.render();
    alert('loaded render');
}

function parsePrice() {
    finalPrice = document.getElementById('final-price').innerHTML;
    finalPriceParsed = '';
    currency = '';
    for(i=0;i<finalPrice.length;i++) {
        char = finalPrice.charAt(i);
        if(char == ',') char = '.';
        // alert(char+", "+i);
        if(!isNaN(char) || char == '.') 
            finalPriceParsed += char;
        if(isNaN(char) && char != '.' && char != ' ')
            currency += char;
    }
    finalPriceParsed = parseInt(finalPriceParsed);
    if( (finalPrice.indexOf('.') != -1 || finalPrice.indexOf(',') != -1) && (finalPrice.indexOf('.00') == -1 && finalPrice.indexOf(',00') == -1) )
        finalPriceParsed += 1;
    
    
    if(document.getElementById('strike-price'))
        strikePrice = document.getElementById('strike-price').innerHTML;
    else 
        strikePrice = finalPrice;
    strikePriceParsed = '';
    for(i=0;i<strikePrice.length;i++) {
        char = strikePrice.charAt(i);
        if(char == ',') char = '.';
        if(!isNaN(char) || char == '.') 
            strikePriceParsed += char;
    }
    strikePriceParsed = parseInt(strikePriceParsed);


    document.getElementById('final-price').innerHTML = currency+finalPriceParsed;
    document.getElementById('final-price-mob').innerHTML = currency+finalPriceParsed;
    if(document.getElementById('strike-price')) {
        document.getElementById('strike-price').innerHTML = currency+strikePriceParsed;
        document.getElementById('strike-mob').innerHTML = currency+strikePriceParsed;
    }
}

const classes = document.body.classList;
let timer = 0;

$(document).ready(function(){
    window.setTimeout(scrollToDefaultPos, 100);
    detectCurrentPage();

     // window.setTimeout(renderSketch, 1000);
    window.setTimeout(function() {
      document.body.classList.add('loaded');
    }, 1000);

    checkWrapper();

    // PARSE PRICE
    if(window.currentPage == window.PAGE_PIANO) {
    	parsePrice();
    	// LOAD VIDEO POSTER
    	document.getElementById('teaser-instrument').setAttribute('poster', isMobile ? 'https://cdn.shopify.com/s/files/1/0452/8911/1710/files/video_poster_mob.jpg' : 'https://cdn.shopify.com/s/files/1/0452/8911/1710/files/video_poster.jpg');
    }
    
    if (timer) {
        clearTimeout(timer);
        timer = null;
    }
    else
        classes.add('stop-transitions');
        timer = setTimeout(() => {
        classes.remove('stop-transitions');
        timer = null;
    }, 100);

    /* ADD TO CART */
    if(window.currentPage == window.PAGE_PIANO) {
        $("#buy-button").click(function() {
            if(!addedToCart) {
                $.ajax({
                    type: "POST",
                    url: "/cart/add",
                    data: $(".product-variant-id").serialize(),
                    beforeSend: function() {
                        document.getElementById('buy-link').innerHTML = '...';
                    },
                    success: function(data) {
                        document.getElementById('buy-link').innerHTML = '&#x7e;'; // TILDE ~
                        cartLink = document.getElementById('menu-link-cart');
                        cartLinkMobile = document.getElementById('menu-link-cart-mob');
                        cartText = cartLink.innerHTML;
                        itemCountStr = cartText.substring(cartText.indexOf('(')+1, cartText.indexOf(')'));
                        itemCount = 1;
                        if(!isNaN(itemCountStr)) {
                            itemCount = parseInt(itemCountStr)+1;
                        }
                        cartLink.innerHTML = 'cart ('+itemCount+')';
                        cartLinkMobile.innerHTML = 'cart ('+itemCount+')';
                        document.getElementById('buy-button').classList.remove('buy-button');
                        document.getElementById('buy-button').classList.add('buy-button-added');
                        addedToCart = true;
                        window.location.href = '/cart';
                      if (typeof rdt === 'function') {
                        rdt('track', 'AddToCart');
                      }
                    },
                });
            }
        });
    }
    
    if(isFirefox && window.currentPage == window.PAGE_PIANO) {
        document.getElementById('text-video-3').playbackRate = 2.0;
        document.getElementById('text-video-3').play();
    }
    $(document).on('keydown', function(event) {
        if (event.key == "Escape" && window.currentPage == window.PAGE_PIANO) {
            stopInstrumentVideo();
        }
    });

    if(window.currentPage == window.PAGE_PIANO && window.innerWidth <= 736) {
        document.getElementById('main-title-mobile').innerHTML = 'HANDCRAFTED PIANO';
    }


    window.scrollTop = $(document).scrollTop();
    refreshMenu();
    $(window).scroll(function(){
        easeScrolling = true;
        scrollTop = window.scrollTop;

        if(window.currentPage == window.PAGE_PIANO && instrumentVideoIsPlaying && scrollTop > 200 && !instrumentVideoClicked) {
            stopInstrumentVideo();
        }
        previousScroll = window.scrollTop;
    });

    $(window).on('resize', function() {
       if(window.currentPage == window.PAGE_HOME && window.innerWidth > 736) {
            document.getElementById('circle-main').style.transform = "rotate(0deg) translate(-50%, -50%)";
            document.getElementById('circle-main').style.filter = "blur(1px)";
            document.getElementById('circle-main').style.height = "50%";
       }
       if (timer) {
           clearTimeout(timer);
           timer = null;
       }
       else
           classes.add('stop-transitions');
           timer = setTimeout(() => {
           classes.remove('stop-transitions');
           timer = null;
       }, 100);
       // $(window).scrollTop(0);
    });

    /* SUBMIT NEWSLETTER */
    $('#input-newsletter').keypress(function (e) {
        if (e.which == 13) {
        	e.preventDefault();
            submitNewsletter();
        }
    });
    try {
        document.getElementById('newsletter-form').addEventListener("submit", (e) => {
            e.preventDefault();
            submitNewsletter();
        });
    } catch(error) {
    	console.log('error with form');
    }
    console.log('js loaded');

    /* HOVER ABOUT */
    if(window.currentPage == window.PAGE_TEAM) {

    }
});

portraitAnimation = [0, 0, 0];
portraitAnimationOn = [false, false, false];

function portraitOn(portraitID) {
    if(portraitAnimation[portraitID] < 5 && portraitAnimationOn[portraitID] ) {
        portraitAnimation[portraitID] += 0.1;
        if(portraitAnimation[portraitID] > 5) portraitAnimation[portraitID] = 5;
        document.getElementById("blur-element-"+portraitID).setAttribute("stdDeviation", portraitAnimation[portraitID]+", 0");
        requestAnimationFrame(function() {portraitOn(portraitID)});
    }
}
function portraitOff(portraitID) {
    if(portraitAnimation[portraitID] > 0 && !portraitAnimationOn[portraitID]) {
        portraitAnimation[portraitID] -= 0.1;
        if(portraitAnimation[portraitID] < 0) portraitAnimation[portraitID] = 0;
        // console.log('Off: '+portraitAnimation[portraitID]+' ('+portraitID+')');
        document.getElementById("blur-element-"+portraitID).setAttribute("stdDeviation", portraitAnimation[portraitID]+", 0");
        requestAnimationFrame(function() {portraitOff(portraitID)});
    } 
}

function submitNewsletter() {
   /* $('#input-newsletter').css('display', 'none');
    $('#newsletter-success').css('display', 'inline-block');
    $('#newsletter-title').css('color', '#000');
    $('#input-newsletter-submit').css('display', 'none');*/
    if (
    document.getElementById('input-newsletter').value.trim().length > 0 &&
    !submittedNewsletter
    ) {
    $.ajax({
      type: 'GET',
      url: 'https://audio.us21.list-manage.com/subscribe/post-json?u=347f6a08b00e1b6aa066161ac&id=ad78384af2&f_id=00ba86e6f0&c=?',
      data: $('#newsletter-form').serialize(),
      cache: false,
      dataType: 'jsonp',
      success: (res) => {
        if (res.result === 'success') {
          document.getElementById("newsletter-title").innerHTML = 'Subscribed!';
          $("#input-newsletter").css("visibility", "hidden");
          //$('#newsletter-success').show();
          submittedNewsletter = true;
        } else {
          console.log('Mailchimp error:', res.msg);
        }
      },
      error: (err) => {
        console.log('AJAX error:', err);
      }
    });
  }
}



function playInstrumentVideo() {
    if(window.currentPage == window.PAGE_PIANO) {
        instrumentVideoClicked = true;
        window.setTimeout( () => {
            instrumentVideoClicked = false;            
        }, 2500);
        document.getElementById('instrument-title').style.opacity = 0;
        document.getElementById('instrument-title').style.filter = 'blur(20px)';
        document.getElementById('play-button-image').style.opacity = 0;
        document.getElementById('watch-trailer').style.opacity = 0;
        document.getElementById('play-button-image').style.filter = 'blur(20px)';
        document.getElementById('watch-trailer').style.filter = 'blur(20px)';
        document.getElementById('container-video-instrument').style.display = 'block';
        document.getElementById('container-video-instrument').style.opacity = '1';
        $('.cursor').css('opacity', '0');
        resetScroll();
        instrumentVideoIsPlaying = true;
    }
}

function stopInstrumentVideo() {
    if(instrumentVideoIsPlaying) {
        document.getElementById('video-instrument').src = document.getElementById('video-instrument').src
        document.getElementById('instrument-title').style.opacity = 1;
        document.getElementById('instrument-title').style.filter = 'blur(1px)';
        document.getElementById('play-button-image').style.opacity = 0.8;
        document.getElementById('watch-trailer').style.opacity = 1;
        document.getElementById('play-button-image').style.filter = 'blur(1px)';
        document.getElementById('watch-trailer').style.filter = 'blur(1px)';
        document.getElementById('container-video-instrument').style.display = 'none';
        document.getElementById('container-video-instrument').style.opacity = '0';
         $('.cursor').css('opacity', '0.8');
        instrumentVideoIsPlaying = false;
    }
}




// function refreshInstrumentScroll() {
//     $(".text-paragraph").each(function() {
//         if($(this)[0].getBoundingClientRect().top < $(window).height()*0.5) {
//            $(this).addClass('text-paragraph-visible');
//         } else if($(this)[0].getBoundingClientRect().top >= $(window).height()*0.9) {
//             $(this).removeClass('text-paragraph-visible');
//         }
//     });
// }

function refreshMenu() {
    /* IF MENU IS ABSOLUTE */
    if(window.currentPage == window.PAGE_PIANO) {
        remainingScroll = $(window).height()-window.scrollTop;
        // buySectionHeight = $(window).height()/100*8;
        buySectionHeight = $('#buy-section').height();
        if(!buySectionStick && remainingScroll <= buySectionHeight) {
            $('#buy-section').addClass('stick');
            $('#buy-title').addClass('buy-title-visible');
            buySectionStick = true;
            if(document.getElementById('strike-price'))
                document.getElementById('strike-mob').style.opacity = '0';
        }
        else if(buySectionStick && remainingScroll > buySectionHeight) {
            buySectionStick = false;
            $('#buy-section').removeClass('stick');  
            $('#buy-title').removeClass('buy-title-visible');
            if(document.getElementById('strike-price'))
                document.getElementById('strike-mob').style.opacity = '1';
        } 
    }  
}

function refreshCursor () {
    if(window.innerWidth > 736) {
        if(window.pos_y+window.scrollTop < $("body").height()-21)
            document.getElementById('cursor').style.top = window.pos_y+window.scrollTop+"px";
        document.getElementById('cursor').style.left = window.pos_x+"px";
    }
}
function refreshPianoCircle() {
    circleRotateTarget = window.pos_y*window.pos_x/10000+(window.scrollTop/20);
    circleBlurTarget = Math.abs(window.innerWidth/2-window.pos_x + window.innerHeight/2-window.pos_y)/400;
    circleScaleTarget = 1+Math.abs(window.innerWidth/2-window.pos_x + window.innerHeight/2-window.pos_y)/4000;
    
    circleRotate = lerp(circleRotate, circleRotateTarget, lerpEaseSlow * 2);
    circleBlur = lerp(circleBlur, circleBlurTarget, lerpEaseSlow * 2);
    circleScale = lerp(circleScale, circleScaleTarget, lerpEaseSlow * 2);
    if(isNaN(circleRotate)) circleRotate = 0;
    if(isNaN(circleBlur)) circleBlur = 1;
    if(isNaN(circleScale)) circleScale = 1;
    if(window.scrollTop > 0 && window.scrollTop < $(window).height()*1.5) {
        document.getElementById('text-image-1').style.transform = "translateX(-50%) translateY(-50%) rotate("+(circleRotate)+"deg) scale("+circleScale+")";
        document.getElementById('text-image-1').style.filter = "blur("+(circleBlur)+"px)";
    } 
}
function refreshAboutCircle() {
    circleRotateTarget = window.pos_y*window.pos_x/10000+(window.scrollTop/20);
    circleBlurTarget = Math.abs(window.innerWidth/2-window.pos_x + window.innerHeight/2-window.pos_y)/200;
    circleScaleTarget = 1+Math.abs(window.innerWidth/2-window.pos_x + window.innerHeight/2-window.pos_y)/4000;
    
    circleRotate = lerp(circleRotate, circleRotateTarget, lerpEaseSlow * 2);
    circleBlur = lerp(circleBlur, circleBlurTarget, lerpEaseSlow * 2);
    circleScale = lerp(circleScale, circleScaleTarget, lerpEaseSlow * 2);
    if(isNaN(circleRotate)) circleRotate = 0;
    if(isNaN(circleBlur)) circleBlur = 1;
    if(isNaN(circleScale)) circleScale = 1;
    document.getElementById('text-image-1').style.transform = "translateX(-50%) translateY(-50%) rotate("+(circleRotate)+"deg) scale("+circleScale+")";
    document.getElementById('text-image-1').style.filter = "blur("+(circleBlur)+"px)";
}

function refreshVideo() {
    if(window.innerWidth > 1250)
        percentage = (window.scrollTop / $(window).height() - 1.7) / 2.0;
    else
        percentage = (window.scrollTop / $(window).height() - 2.5) / 2.0;
    if(percentage < 0) percentage = 0;
    if(percentage > 1) percentage = 1;
    videoCurrentTime = document.getElementById('text-video-3').duration * percentage;
    if(isNaN(videoCurrentTime)) videoCurrentTime = 0;
    document.getElementById('text-video-3').currentTime = videoCurrentTime;
}

function resetScroll() {
    $('html, body').animate({ scrollTop: 0 }, 'slow');
}


function refreshScroll() {
    window.scrollTop = $(document).scrollTop();
    refreshCursor();
    refreshMenu();
    if(window.currentPage == window.PAGE_PIANO && window.scrollTop > 0) {
        refreshPianoCircle();
        if(!isFirefox)
            refreshVideo();
    } else if(window.currentPage == window.PAGE_ABOUT || window.currentPage == window.PAGE_CART) {
        refreshAboutCircle();
    } 

    window.requestAnimationFrame(refreshScroll);
}

function setupScroll() {
    scrollPos = $(document).scrollTop();
    window.requestAnimationFrame(refreshScroll);
}



window.addEventListener("DOMContentLoaded", setupScroll);


// t = time, b = beginning value, c = change in value, d = duration


function easeOut (t, b, c, d) {
    return -c * (t /= d) * (t - 2) + b;
}
function li(a, b, n) {
    return (1 - n) * a + n * b;
}
const lerpEase = 0.07 * 1.2 * 0.2;

const lerpEaseSlow = 0.07 * 1.2 * 0.2;
function lerp(p1, p2, t) {
    return p1 + (p2 - p1) * t;
}